export const REMOVE_SAVED_DEAL_MUTATION = `
  mutation RemoveSavedDealMutation($offerId: ID!) {
    me {
      unfollowOffer(offerId: $offerId)
    }
  }
`;
